module.exports = __webpack_public_path__ + "img/tips.7e1160f4.png";